<template>
  <mu-list class="hotelList">
    <mu-list-item titleClass="title" v-for="item in HotelList" v-on:click="choose(item.HotelCode)" style="text-align:left;">
    	<!--酒店图片-->
      <div :style=" 'background: url('+ item.HotelImg + ')   ;   background-size:cover;  float:left ; width: 2.12rem ; height: 1.59rem;  font-size:0.18rem; min-height:0.7rem ; ' ">
				<div v-if="item.LabelTop " style="  position:absolute ; background-color:red; color:white; padding: 0 0.05rem">
					{{ item.LabelTop }}
				</div>
				<span v-if="item.LabelBottom " style="   width: 2.12rem;height:0.32rem; text-align:center ;  top:1.45rem ;position:absolute  ; color:white;  background: url(../../../static/search/pic_bg.png) repeat-x ;">
					{{ item.LabelBottom }}
				</span>
      </div>
      <!--右边-->
      <div style="width:68%; float:right;margin-top:-0.08rem">
        <div style="font-weight:bold ; color:#777 ; font-size: 0.28rem; line-height:0.4rem;">
          {{ item.HotelName }}
        </div>
				<!--地址-->
				<div v-if='showAddress' class="hotelLoc" style='white-space: nowrap; margin:0.1rem 0'>
          <mu-icon style="position:relative;" value="room" color="#A5A5A5" :size='13' />
          <span style='width:4.3rem; height:0.5rem'> {{item.Address}} </span>
        </div>
				<!--评论-->
        <div v-if='showCommonts'>{{item.CommentCount}}条评论</div>
        <div style="height:0.4rem" v-if="item.ListGreen.length == 0  && item.ListYellow.length == 0  && !item.BBreak   && !item.BRoom    "> </div>
				<stars :score='item.CommentScore'/>
        <span style=" margin-left:0.3rem ">
          <img v-for="ser in item.HotelServiceList" :src="'../../../static/service/' + serviceIcon(ser.KeyId) + '.png'" v-bind:class="serviceIcon(ser.KeyId)" />
        </span>
        <span class="lowestPrice" v-if="item.LowestPrice != '满房'" v-bind:class="{ 'upgap' : item.LabelCount>3 }">
					<span class="priceSign">￥ </span>
					<span class="priceShow">{{item.LowestPrice}}</span>
					<span class="priceTxt"> 起</span>
        </span>
        <span class="lowestPrice" v-if="item.LowestPrice == '满房'" v-bind:class="{ 'upgap' : item.LabelCount>3 }"  >
          <span class="priceShow">{{item.LowestPrice}}</span>
        </span>
        <div style="font-size:0.18rem ; line-height:0.6rem ;  width:100% ">

          <!--<span v-for="   ser in item.HotelServiceList" >
            <span class="GreenLabel" v-if=" ser.KeyId == 51 && ser.InfoValueCH == 'True'   ">早餐购</span>
          </span>-->

          <span class="GreenLabel" v-if="  item.BBreak ">早餐购</span>
          <span class="GreenLabel" v-if="  item.BRoom  ">自助选房</span>


          <span class="YelloLabel" v-if="  item.ListYellow[0]!=null  ">{{ item.ListYellow[0] }}</span>
          <span class="YelloLabel" v-if="  item.ListYellow[1]!=null  ">{{ item.ListYellow[1] }}</span>
          <span class="GreenLabel" v-if="  item.ListGreen[0]!=null  ">{{ item.ListGreen[0] }}</span>
          <span class="GreenLabel" v-if="  item.ListGreen[1]!=null  ">{{ item.ListGreen[1] }}</span>
          <span class=" BackLabel " style=" white-space:nowrap " v-if="item.LabelBack">
            {{ item.LabelBack}}
          </span>
        </div>
      </div>
    </mu-list-item>
  </mu-list>
</template>

<script>
import service from '../utils/hotelService.js'
import stars from '../components/stars'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
    }
  },
	components:{
		stars
	},
	props: {
    HotelList: {
      type: Array,
      required: true
    },
		showAddress:{
			type: Boolean,
      default: false
		},
		showCommonts:{
			type: Boolean,
      default: false
		}
  },
	methods: {
		...mapMutations([
      'setG_currentInfo'
    ]),
		fullStar(input) {
      return Math.floor(input);
    },
    nullStar(input) {
      return Math.floor(5 - input);
    },
    halfStar(input) {
      if (this.fullStar(input) == input) {
        return false;
      }
      return true;
    },
		choose(code) {
      var model = this.g_currentInfo;
      //修改酒店编码
      model.HotelCode = code;
      this.setG_currentInfo(model);
      this.$router.push({ path: '/search/homeList' });
    },
		//获取url
    serviceIcon: service.serviceIcon
	},
	computed: {
		...mapGetters([
      'g_currentInfo'
    ])
	}
}
</script>

<style lang="less" scoped>
@import "../assets/theme.less";
@import "../assets/common.less";


.upgap{

  top:0.6rem;
}




  .hotelList {
    background-color: #FFF;
    padding: 0px;
    height: auto;
    .mu-item {
      border-bottom: 1px solid #f1f1f1;
    }
    .mu-avatar img {
      border-radius: 0;
    }
    .hotelLoc {
      color: @textColor;
      font-size: 0.22rem;
    }
    .lowestPrice {
      right: 0.2rem;
      position: absolute;
      margin-bottom:0.4rem;
      font-size: 0.22rem;
      .priceSign {
        color: @primaryOrange;
      }
      .priceShow {
        color: @primaryOrange;
        font-size: 0.36rem;
      }
      .priceTxt {
        color: @textColor;
      }
      padding-right:0.2rem;
    }
  }

	.BackLabel {
		font-size:0.2rem;
		background-color: #27ba69;
		padding: 0.02rem 0.08rem;
		color: #fff;
		border-radius: 0.04rem;
		font-weight:normal;
    line-height:0.3rem
	}

	// 圆角
	.GreenLabel {
		background-color: #edf7f4;
		padding: 0.04rem 0.1rem;
		color: #6ca896;
		border-radius: 0.04rem;
	}

	.YelloLabel {
		background-color: #ffecdd;
		padding: 0.04rem 0.1rem;
		color: #ff8f38;
		border-radius:  0.04rem;
	}
</style>


// WEBPACK FOOTER //
// hotelList.vue?7608c815